import { useContext } from "react";
import { AuthorizationContext } from "../../contexts/authorizationContext/AuthorizationContext";

const useAuthorizationContext = () => {
    const context = useContext(AuthorizationContext);

    if (!context) {
        throw new Error('useAuthorizationContext must be used within a AuthorizationProvider.');
    }
    return context;
};

export default useAuthorizationContext;